function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import applyReducer from './applyReducer';
import constants from '../constants/annotationSelectionConstants';
import reportAnnotationConstants from '../constants/reportAnnotationConstants';
import formConstants from '../constants/formConstants';
import commonAnnotationTools from '../components/common/pdf/annotations/commonAnnotationTools';
import interpolate from '../components/common/pdf/annotations/interpolate';
export const DEFAULT_COLOR = '1 0 0 1';
const initialState = {
  selectedAnnotation: null,
  // selectableType is now a composite key: camelCase(renderType) + '__' +
  // camelCase(formTypeIdentifier) if both are present
  selectableType: null,
  // e.g., 'note__fabHeat', 'note__fabMagneticTest', 'ink', etc.
  editMode: false,
  annotationContext: null,
  // 'form' or 'report'
  defaultColor: DEFAULT_COLOR,
  trackCursorPosition: false,
  isDrawing: false,
  clickedEntity: {},
  points: [],
  lines: []
};
const clearSelection = state => _objectSpread({}, state);
const setAnnotationContext = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  annotationContext: action.payload
});
const setClickedEntity = (state, {
  clickedEntity
}) => _objectSpread(_objectSpread({}, state), {}, {
  clickedEntity
});
const setSelectableType = (state, action) => {
  var _action$payload$type, _action$payload, _action$payload$canEd, _action$payload2;
  return _objectSpread(_objectSpread({}, state), {}, {
    selectableType: (_action$payload$type = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.type) !== null && _action$payload$type !== void 0 ? _action$payload$type : null,
    editMode: (_action$payload$canEd = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.canEdit) !== null && _action$payload$canEd !== void 0 ? _action$payload$canEd : false
  });
};
const setDefaultColor = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  defaultColor: action.payload
});
const trackCursor = (state, {
  point,
  rotation,
  pageNumber
}) => {
  const {
    selectableType: type
  } = state;
  let {
    points
  } = state;
  const lastPoint = points.length ? points[points.length - 1] : null;

  // if the new point falls on a different page then the previous, perform special operations
  if (lastPoint !== null) {
    const lastLastPoint = points.length > 1 ? points[points.length - 2] : null;
    const annotations = commonAnnotationTools.groupPointsByPage(points);
    const lastAnnotation = annotations.length ? annotations.pop() : null;
    if (pageNumber !== lastPoint.pageNumber) {
      // if the new point is on a page that already has points, roll back to that page
      let needsTriming = points.map(pt => pt.pageNumber).some(page => page === pageNumber);
      // only allow one line per page
      if (type === 'line' && needsTriming) {
        // lines should only be drawn 1 to a page, if drawing back onto a page that already has
        // a line, pop off all the points on the stack between the new point and the old point
        // (resulting in a line with a new endpoint on the old page)
        while (needsTriming) {
          if (points[points.length - 1].pageNumber === pageNumber) {
            needsTriming = false;
          } else {
            points.pop(); // trim the point that's on the old page
          }
        }
      } else if (lastLastPoint !== null) {
        // always interpolate last line
        points = interpolate.ending(points, lastPoint, lastLastPoint, lastAnnotation, type);
      }
    } else if (annotations.length && lastAnnotation.length === 1) {
      points = interpolate.beginning(points, lastPoint, lastAnnotation, point);
    }
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    points: [...points, _objectSpread(_objectSpread({}, point), {}, {
      rotation,
      pageNumber
    })],
    trackCursorPosition: true
  });
};
const trackReset = state => _objectSpread(_objectSpread({}, state), {}, {
  points: [],
  trackCursorPosition: false
});
const startDrawing = state => _objectSpread(_objectSpread({}, state), {}, {
  isDrawing: true
});
const stopDrawing = state => _objectSpread(_objectSpread({}, state), {}, {
  isDrawing: false
});
const stopDrawingAndReset = state => _objectSpread(_objectSpread({}, state), {}, {
  isDrawing: false,
  trackCursorPosition: false,
  points: []
});
const reducers = {
  [constants.CLEAR_SELECTION]: clearSelection,
  [reportAnnotationConstants.CREATE_INK]: stopDrawing,
  [reportAnnotationConstants.CREATE_LINE]: stopDrawing,
  [formConstants.ANNOTATION_CREATE_SUCCESS]: stopDrawingAndReset,
  [constants.SET_ANNOTATION_CONTEXT]: setAnnotationContext,
  [constants.SET_CLICKED_ENTITY]: setClickedEntity,
  [constants.SET_DEFAULT_COLOR]: setDefaultColor,
  [constants.SET_SELECTABLE_TYPE]: setSelectableType,
  [constants.TRACK_CURSOR]: trackCursor,
  [constants.TRACK_RESET]: trackReset,
  [constants.START_DRAWING]: startDrawing
};
export default applyReducer(reducers, initialState);